import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { connect, useDispatch } from "react-redux";

// ANT DESIGN IMPORTS
import {
  Input,
  Row,
  Typography,
  Card,
  Table,
  Spin,
  Select,
  Statistic,
} from "antd";

// PROJECT IMPORTS
import MainLayout from "../../../components/layouts/MainLayout";
import TopContent from "../../../components/layouts/TopContent";
import appStatic from "../../../config/appStatic";
import appLabel from "../../../config/appLabel";
import definedApi from "../../../services/definedApi";
import { BOM } from "../../../services/definedMethod";
import cnt from "../../../services/definedConstant";
import { rightAction } from "../../../redux/actions";
import DownloadTableButtons from "../../../components/DownloadTableButtons";

const rowSelection = {
  onChange: (selectedRowKeys, selectedRows) => {},
  getCheckboxProps: (record) => ({
    disabled: record.name === "Disabled User",
    name: record.name,
  }),
};

const columns = [
  {
    title: "Branch Name",
    dataIndex: "branchName",
  },
  {
    title: "	Product Name",
    dataIndex: "productName",
  },
  {
    title: "Count",
    dataIndex: "count",
  },
  {
    title: "Outstanding",
    dataIndex: "outstanding",
  },
  {
    title: "Percentage",
    dataIndex: "percentage",
  },
];

const GLA0900 = (props) => {
  const { userData, rightBtn, rightAction } = props;
  const { monthList } = appStatic;
  const { session } = userData;
  const { Text } = Typography;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [tableCount, setTableCount] = useState("10");
  const [advanceSearchList, setAdvanceSearchList] = useState([]);
  const [originalList, setOriginalList] = useState([]);

  //DECLARED METHODS
  function handleSearchInTable(searchKey) {
    searchKey = searchKey.target.value;
    // console.log(searchKey);

    if (!searchKey) {
      setAdvanceSearchList(originalList);
      return;
    }
    // console.log(originalList);
    const filterBySearch = originalList.filter((item) =>
      item?.transactionDate?.includes(searchKey)
    );
    // console.log(filterBySearch);
    setAdvanceSearchList(filterBySearch);
  }

  function selectTableCount(value) {
    setTableCount(value);
  }

  //END METHODS DECLARED

  useEffect(() => {
    // getJournalEntriesAction();
    // //DISABLE ALL RIGHTSIDEBAR ACTION
    // dispatch({
    //   type: cnt.CLEAR_RIGHT_BTN,
    // });
    // rightAction(cnt.RIGHT_ADD_BTN);
  }, []);

  const getJournalEntriesAction = () => {
    let body = {
      session,
    };

    BOM.FetchReqAction(body, definedApi.GetJournalEntries, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
      } else {
        const objList = res.pageItems;
        let tempArray = [];

        objList.forEach((element) => {
          tempArray.push({
            key: element?.id,
            id: element?.id ? element?.id : "-",
            branch: element?.officeName ? element?.officeName : "-",
            transactionDate: element?.transactionDate
              ? `${element?.transactionDate[2]} ${
                  monthList[element?.transactionDate[1] - 1]
                } ${element?.transactionDate[0]}`
              : "-",
            transactionId: element?.transactionId
              ? element?.transactionId
              : "-",
            type: element?.glAccountType?.value
              ? element?.glAccountType?.value
              : "-",
            createdBy: element?.createdByUserName
              ? element?.createdByUserName
              : "-",
            account: element?.glAccountName
              ? `${element?.glAccountName} (${element?.glAccountCode})`
              : "-",
            debit:
              element?.entryType?.value?.toLowerCase() === "debit"
                ? element?.amount
                : "-",
            credit:
              element?.entryType?.value?.toLowerCase() === "credit"
                ? element?.amount
                : "-",
            transactionTag: element?.entryType?.value
              ? element?.entryType?.value === "DEBIT"
                ? "Dr"
                : element?.entryType?.value === "CREDIT"
                ? "Cr"
                : "-"
              : "-",
            amount: element?.amount ? (
              <Statistic
                value={element?.amount}
                precision={2}
                valueStyle={{ fontSize: "16px" }}
              />
            ) : (
              "-"
            ),
            amountToUse: element?.amount ? element?.amount : 0,
          });
        });

        //Display only active records list on the table; this will change after switching from authorized to disabled and vice versa.
        // setAdvanceSearchList(tempArray.filter((item) => item.disabled === false));
        setAdvanceSearchList(tempArray);

        //keep the orginal data to use after gList is modified when change from autorise to disable
        setOriginalList(tempArray);

        //STOP LOAD
        setIsLoading(false);
      }
    });
  };

  // FLOAT METHODS
  function handleOnView() {
    // console.log(selectedRow);return
    delete selectedRow.amount;
    selectedRow.amount = selectedRow.amountToUse;
    const { detailBtn } = rightBtn;
    if (detailBtn.toLowerCase() === "primary") {
      navigate("/view-gla0900", { state: selectedRow });
    } else {
      console.log("Please choose a record from the table to open");
    }
  }

  function handleOnCreate() {
    const { addBtn } = rightBtn;
    if (addBtn.toLowerCase() === "primary") {
      navigate("/add-gla0900", { ofObj: selectedRow });
    } else {
      console.log("Could not open the link");
    }
  }

  const onSelectItemAction = (selectedRowKeys, objParam) => {
    //HOLD THE OBJECT SELECTED HERE
    setSelectedRow(objParam[0]);
    [cnt.RIGHT_DETAIL_BTN].map((item) => {
      dispatch({
        type: item,
      });
    });
  };

  return (
    <MainLayout
      isEnableRightSidebar={true}
      onView={handleOnView}
      onAdd={handleOnCreate}
    >
      <TopContent
        pageTitle={appLabel.adHocQuerySearchForLoans}
        pageItems={appStatic.adHocQuerySearchForLoansItemList}
      />

      <Card
        title={`${appLabel.advanceSearch} List`}
        style={{
          boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
          borderRadius: 20,
        }}
      >
        {/*RENDER TABLE LIST HERE*/}

        <Spin spinning={isLoading} size="large">
          <Row style={{ marginBottom: 20 }}>
            <div style={{ marginBottom: "auto" }}>
              <Text style={{ marginRight: 8 }}>Show</Text>
              <Select
                defaultValue={tableCount}
                options={[
                  { value: "5", label: "5" },
                  { value: "10", label: "10" },
                  { value: "25", label: "25" },
                  { value: "50", label: "50" },
                ]}
                onSelect={selectTableCount}
              />
              <Text style={{ marginLeft: 8 }}>Entries</Text>
            </div>

            <div style={{ margin: "0px 50px" }}>
              <Input
                onChange={handleSearchInTable}
                placeholder="Search by Product Name..."
                style={{
                  width: 400,
                }}
              />
            </div>
            <DownloadTableButtons
              downloadData={advanceSearchList}
              columns={columns}
              fileName={"Advance Search List"}
            />
          </Row>
          <Table
            rowSelection={{
              type: "radio",
              ...rowSelection,
              onChange: onSelectItemAction,
            }}
            columns={columns}
            dataSource={advanceSearchList}
            bordered
            pagination={{
              position: "bottomCentre",
              pageSize: tableCount,
            }}
          />
        </Spin>
      </Card>
    </MainLayout>
  );
};
const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

const mapDispatchToProps = { rightAction };
export default connect(mapStateToProps, mapDispatchToProps)(GLA0900);
